import React from 'react';
import { ClinicalTypeEnum, DisciplineEnum } from '@generated';
import { AutocompleteSearchFormField, type AutocompleteSearchFormFieldProps } from '~/shared/forms/controls/fields/AutocompleteSearchFormField';
import type { SieveFilterModel } from '~/util/sieve/filter';

function getClinicalTypeIds(disciplineId: number, startOfCare: boolean): number[] {
	switch (disciplineId) {
		case DisciplineEnum.SkilledNursing:
			return startOfCare ? [ClinicalTypeEnum.RN] : [ClinicalTypeEnum.RN, ClinicalTypeEnum.LPN];
		case DisciplineEnum.PhysicalTherapy:
			return [ClinicalTypeEnum.PT];
		case DisciplineEnum.OccupationalTherapy:
			return [ClinicalTypeEnum.OT];
		case DisciplineEnum.SpeechTherapy:
			return [ClinicalTypeEnum.ST];
		case DisciplineEnum.MedicalSocialWorker:
			return [ClinicalTypeEnum.MSW];
		case DisciplineEnum.HomeHealthAide:
			return [ClinicalTypeEnum.HHA];
		default:
			throw new Error('Invalid discipline for referral assignment');
	}
}

export interface LegacyClinicianAutocompleteProps extends Omit<AutocompleteSearchFormFieldProps<'user'>, 'searchType'> {
	disciplineId: number;
	startOfCare?: boolean;
}

export function LegacyClinicianAutocomplete({ disciplineId, startOfCare = false, ...props }: LegacyClinicianAutocompleteProps) {
	const filters: SieveFilterModel[] = [
		{ name: 'clinicalTypeId', operator: '==', value: getClinicalTypeIds(disciplineId, startOfCare).join('|') },
		{ name: 'active', operator: '==', value: true }
	];
	return <AutocompleteSearchFormField {...props} searchType="user" additionalFilters={filters} />;
}
